// Theme Layout Preview Script

(function (): void {
  'use strict';

  function initThemeLayoutPreview(): void {
    // Detect iframe or preview mode
    const isIframe = window.self !== window.top;
    const isPreviewMode =
      isIframe ||
      (document.body && document.body.classList.contains('in-preview-iframe')) ||
      location.search.indexOf('preview=1') !== -1;

    if (!isPreviewMode) {
      return;
    }

    const root = document.documentElement || document.body;
    if (root) root.classList.add('in-preview-iframe');
    if (document.body) document.body.classList.add('in-preview-iframe');

    // Create floating inspector hover pill badge if it doesn't exist
    let hoverBadge = document.getElementById('previewHoverBadge');
    if (!hoverBadge && document.body) {
      hoverBadge = document.createElement('div');
      hoverBadge.id = 'previewHoverBadge';
      hoverBadge.className = 'preview-hover-badge';
      hoverBadge.style.display = 'none';
      document.body.appendChild(hoverBadge);
    }

    let currentHoveredBlock: HTMLElement | null = null;

    function findBlockTarget(target: Element | null): HTMLElement | null {
      if (!target || target === document.body || target === document.documentElement) return null;
      return target.closest<HTMLElement>(
        '[data-content-item-id], section, header, footer, nav, [class*="widget-"], [class*="acms-"], .loumars-flow-widget-wrapper'
      );
    }

    function updateHoverBadge(block: HTMLElement | null): void {
      if (currentHoveredBlock && currentHoveredBlock !== block) {
        currentHoveredBlock.classList.remove('preview-hover-block');
      }
      if (!block || !hoverBadge) {
        if (hoverBadge) hoverBadge.style.display = 'none';
        currentHoveredBlock = null;
        return;
      }
      currentHoveredBlock = block;
      currentHoveredBlock.classList.add('preview-hover-block');

      const type =
        block.getAttribute('data-widget-type') ||
        block.closest('[data-widget-type]')?.getAttribute('data-widget-type') ||
        (typeof block.className === 'string'
          ? block.className.match(/(widget-[a-z0-9-]+|acms-[a-z0-9-]+)/i)?.[1] || ''
          : '') ||
        'Content Block';
      const displayType = type.replace(/^Widget-?/i, '').replace(/Widget$/i, '');
      hoverBadge.innerHTML = '✏️ <span>Edit: ' + displayType + '</span>';

      const rect = block.getBoundingClientRect();
      const top = Math.max(10, rect.top + 8);
      const left = Math.max(10, rect.left + 12);

      hoverBadge.style.top = top + 'px';
      hoverBadge.style.left = left + 'px';
      hoverBadge.style.display = 'flex';
    }

    document.addEventListener('mouseover', function (e: MouseEvent): void {
      const target = e.target as Element | null;
      if (!target || (hoverBadge && target.closest('#previewHoverBadge'))) return;
      const block = findBlockTarget(target);
      if (block) {
        updateHoverBadge(block);
      } else {
        updateHoverBadge(null);
      }
    });

    window.addEventListener(
      'scroll',
      function (): void {
        if (currentHoveredBlock) updateHoverBadge(currentHoveredBlock);
      },
      { passive: true }
    );

    window.addEventListener('message', function (e: MessageEvent): void {
      if (!e.data || !e.data.action) return;
      if (e.data.action === 'highlightBlock' && e.data.contentItemId) {
        const target = document.querySelector<HTMLElement>(
          '[data-content-item-id="' + e.data.contentItemId + '"]'
        );
        if (target) {
          document.querySelectorAll('.preview-active-block').forEach(function (el) {
            el.classList.remove('preview-active-block');
          });
          target.classList.add('preview-active-block');
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          updateHoverBadge(target);
        }
      }
    });

    function handleBlockSelection(block: HTMLElement | null): void {
      if (!block) return;
      const id =
        block.getAttribute('data-content-item-id') ||
        block.closest('[data-content-item-id]')?.getAttribute('data-content-item-id');
      const type =
        block.getAttribute('data-widget-type') ||
        block.closest('[data-widget-type]')?.getAttribute('data-widget-type') ||
        '';
      if (!id) return;

      document.querySelectorAll('.preview-active-block').forEach(function (el) {
        el.classList.remove('preview-active-block');
      });
      block.classList.add('preview-active-block');

      const payload = { action: 'selectBlock', contentItemId: id, contentType: type };
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(payload, '*');
      }
      if (window.opener) {
        window.opener.postMessage(payload, '*');
      }
    }

    if (hoverBadge) {
      hoverBadge.addEventListener('click', function (e: MouseEvent): void {
        e.stopPropagation();
        if (currentHoveredBlock) {
          handleBlockSelection(currentHoveredBlock);
        }
      });
    }

    document.addEventListener(
      'click',
      function (e: MouseEvent): void {
        const target = e.target as Element | null;
        if (!target || (hoverBadge && target.closest('#previewHoverBadge'))) return;
        const block = findBlockTarget(target);
        if (block) {
          const link = target.closest('a');
          if (link) {
            e.preventDefault();
          }
          handleBlockSelection(block);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeLayoutPreview);
  } else {
    initThemeLayoutPreview();
  }
})();
